import { Alert, Box, Card, CardContent } from "@mui/material";
import React, { ReactNode } from "react";
import { PanelTitle } from "../../Panel/PanelTitle";

interface DialogSettingsCardProps {
  title?: string | ReactNode;
  info?: string | ReactNode;
  actions?: ReactNode;
  cardContent?: ReactNode;
  content?: ReactNode;
  showCard?: boolean;
  fitToContainerHeight?: boolean;
}

export const DialogSettingsCard = ({
    title,
    info,
    actions,
    cardContent,
    content,
    showCard = true,
    fitToContainerHeight = false,
}: DialogSettingsCardProps) => (
    <Card
        elevation={0}
        sx={{
            border: showCard ? "1px solid" : null,
            borderColor: "divider",
            ...(fitToContainerHeight
                ? {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%"
                }
                : {}),
        }}
    >
        {(!!title || !!info || !!cardContent || !!actions) &&
            <CardContent>
                {title ? <PanelTitle title={title} /> : null}
                {info ? <Alert sx={{ marginTop: "10px", whiteSpace: "pre-line" }} severity="info">{info}</Alert> : null}
                {actions}
                {cardContent}
            </CardContent>
        }
        {(fitToContainerHeight
            ? <Box sx={{ flexGrow: 1, height: 0, flexDirection: "column" }}>{content}</Box>
            : content
        )}
    </Card>
);
